export const CheckStepIcon = ({
  className,
  size = 20,
  fill = "currentColor",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M7.73136 11.8878L15.6984 3.94202C15.7586 3.88115 15.8301 3.83285 15.9088 3.79991C15.9875 3.76696 16.0718 3.75 16.157 3.75C16.2422 3.75 16.3265 3.76696 16.4052 3.79991C16.4839 3.83285 16.5553 3.88115 16.6155 3.94202L18.5599 5.87342C18.6202 5.93423 18.668 6.00643 18.7006 6.08592C18.7332 6.1654 18.75 6.25059 18.75 6.33663C18.75 6.42267 18.7332 6.50787 18.7006 6.58735C18.668 6.66683 18.6202 6.73904 18.5599 6.79984L8.1575 17.308C8.09731 17.3689 8.02583 17.4171 7.94715 17.4501C7.86846 17.483 7.78413 17.5 7.69895 17.5C7.61378 17.5 7.52944 17.483 7.45076 17.4501C7.37208 17.4171 7.3006 17.3689 7.2404 17.308L1.43968 11.4156C1.31823 11.2928 1.25 11.1263 1.25 10.9528C1.25 10.7792 1.31823 10.6127 1.43968 10.49L3.38406 8.52583C3.44425 8.46495 3.51573 8.41666 3.59441 8.38372C3.67309 8.35077 3.75743 8.33381 3.84261 8.33381C3.92778 8.33381 4.01212 8.35077 4.0908 8.38372C4.16948 8.41666 4.24096 8.46495 4.30116 8.52583L7.73136 11.8878Z"
      fill={fill}
    />
  </svg>
);
